import {h, Fragment} from "preact"
import { getColorSwatchSrc, getImageSize, getProductImages } from "../helpers"
import { SerpElement, useProductFilters } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

export default function Swatches ({product, colors, activeVariant, variantSwitch, productUrl = null}) {
  const visibleSwatches = colors.slice(0, 4);
  const remainingCount = colors.length - visibleSwatches.length;

  return (
    <div class="ns-color-swatches" role="radiogroup" aria-label="Color options">
      {visibleSwatches.map((color) => (
        <div
          onClick={() => variantSwitch(color)}
          className={`ns-color-swatch ${color.id === activeVariant ? 'active' : ''}`}
          style={`background-image:url(${color.src})`}
          tabIndex={color.id === activeVariant ? 0 : -1}
          role="radio"
          aria-label={`${"color-"+color.name.toLowerCase().replace(/\s+/g, '-')}`}
          aria-checked={ `${ color.id === activeVariant ? true : false }` }
        >
        </div>
      ))}
      {remainingCount > 0 && (
        <SerpElement
          class="ns-color-swatches-remain"
          as="a"
          hit={{url: productUrl}}>
          {`+${remainingCount}`}
        </SerpElement>
      )}
    </div>
  );
}
